import * as loginActions from '../actions/auth'
import * as appActions from '../actions/app'
import {setStore as setStoreForRequests} from '../../lib/util/request/middleware'

export default function(store){
	let tokenTimer

	setStoreForRequests(store)

	return next => action => {
		const ret = next(action)
		// Start the token refresh timer when the user logs in
		if(action.type === loginActions.LOGIN_SUCCESS){
			clearTimeout(tokenTimer)
			tokenTimer = _setTimeout(store, store.getState().Auth.token.expires * 0.8)
		}

		// Stop the timer when the user logs out or is locked out
		if(action.type === appActions.APP_RESET_STATE || action.type == loginActions.LOGIN_LOCK){
			tokenTimer = clearTimeout(tokenTimer)
		}

		return ret
	}
}

function _setTimeout(store, timeInSeconds, callback=false){
	return setTimeout(() => {
		console.log("Starting token refresh")
		const token = store.getState().Auth.token

		if(token && token.refreshToken){
			const prom = store.dispatch(loginActions.refreshToken())
				.then(() => _setTimeout(store, timeInSeconds))
				.catch((e) => {
					console.log('Failed getting refresh token, trying again in 1 minute: ' + e.message)
					store.dispatch(loginActions.showLockScreen()) // Force a re-login
				})

			if(callback){
				prom.then(callback)
			}
		}else{
			console.log("Failed refreshing token, the user is not logged in")
			store.dispatch(loginActions.showLockScreen()) // Force a re-login
		}

	}, timeInSeconds * 1000)
}



// WEBPACK FOOTER //
// ./node_modules/mb-app-common/store/middleware/token-refresh.js